import { EntityAvatar } from 'components/UI';
import { ICertificateFullInfo, TransferType } from '@repo/types';
import { Company, Customer } from 'types';
import { formatedDate } from 'utils/date';
import { getOwner } from 'utils/parsers';

export const TransferInInfoSection = ({ certificate }: { certificate: ICertificateFullInfo }) => {
  const ownerData = getOwner(
    certificate.customer as unknown as Customer,
    certificate.company as unknown as Company,
    certificate.transfer?.type as TransferType
  );

  const transferDate = formatedDate({
    date: certificate.transfer?.created_at,
    // The CANONICAL app-wide display format (VERA-304/VERA-924, see utils/date.ts).
    // Briefly changed here on the assumption it was the outlier; it is the rule,
    // and the field rows' MM/dd/yyyy is what deviates.
    format: 'MMM do yyyy, h:mm a',
  });

  return (
    <div className='flex relative items-start gap-4'>
      {/* `getOwner` already returns which kind of party this is — a brand on a Primary
          transfer, a person on a peer-to-peer one — so the shape follows that rather
          than the hardcoded `noImageIcon='company'` this used to pass, which labelled
          every sender a company AND circle-cropped the brand's logo. */}
      <EntityAvatar
        entity={ownerData?.type === 'company' ? 'company' : 'person'}
        src={ownerData?.image ?? undefined}
        name={ownerData?.title}
        size={40}
      />
      {/* Reproduces the text block the shared Avatar used to render inline (16px title,
          14px grey timestamp, 14px description at mt-2) now that the avatar is shape-aware
          and presentational only. */}
      <div>
        <p className='text-[16px] leading-5 font-normal'>{ownerData?.title}</p>
        <p className='text-[14px] leading-5 font-normal text-gray-500'>{transferDate}</p>
        <p className='text-[14px] leading-5 mt-2 font-normal text-gray-700'>
          {`${ownerData?.title} has transferred this item to you.`}
        </p>
      </div>
    </div>
  );
};
